export function headerAction() {
  const body = document.querySelector('body');
  const headerNav = document.querySelector('.js-headerNav');
  const headerItem = document.querySelectorAll('.js-headerItem');
  const headerItemList = Array.prototype.slice.call(headerItem, 0);
  const headerHamburger = document.querySelector('.js-headerHamburger');

  /** hamburger action */
  headerHamburger.addEventListener('click', () => {
    if (headerHamburger.classList.contains('is-active')) {
      headerHamburger.classList.remove('is-active');
      headerNav.classList.remove('is-view');
      body.classList.remove('is-fixed');
    } else {
      headerHamburger.classList.add('is-active');
      headerNav.classList.add('is-view');
      body.classList.add('is-fixed');
    }
  });

  /** hamburger in list -> all close inpage scroll */
  headerItemList.forEach((targetBox) => {
    targetBox.addEventListener('click', () => {
      headerHamburger.classList.remove('is-active');
      headerNav.classList.remove('is-view');
      body.classList.remove('is-fixed');
    });
  });
}
